import { useCallback, useEffect, useState } from 'react';
import { useErrorInputs } from '../../../hooks/useErrorInputs';
import { useForm } from '../../../hooks/useForm';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../../../hooks/useNotification';
import { callApi } from "../../../services/api.service";
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useDianAutocomplete } from '../../../hooks/useDianAutocomplete';
import { calculateDV } from '../../../utils/invoice';
import { useLocation } from 'react-router-dom';

export default function useManageProvider() {
    const provider = {
        // LegalInformation
        type_identification: '',
        // identification: config?.identification || '',
        identification_digit: '',
        business_name: '',
        email: '',
        society_type: '',
        company_type: '',
        supplier_tax_scheme: '',
        supplier_tax_level_code: [],
        // EconomicActivity
        type_ciiu: '',
        code_ciiu: '',
        description_ciiu: '',
        // location
        location: [],
        // LegalRepresen
        reprecentant_type: '',
        reprecentant_id_type: '',
        reprecentant_id: '',
        reprecentant_name: '',
        // bankingInfomation
        type_account: '',
        number_account: '',
        banking_company: '',
        banking_office: '',
        // financialInformation
        total_assets: 0,
        total_liabilities: 0,
        patrimony: 0,
        monthly_income: 0,
        expenses: 0,
        other_income: 0,
        cutoff_date_information: new Date(),
    };

    const { t } = useTranslation();
    const location = useLocation();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const [values, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(provider);
    const [errorInputs, , , validForm] = useErrorInputs({});
    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isNitDisabled, setIsNitDisabled] = useState(false);

    const { loadingDian, fetchDianInfo } = useDianAutocomplete({
        token: userSession?.token,
        values,
        handleDirectInputChange,
        sendNotification,
        fieldMap: {
            business_name: 'businessName',
            email: 'email'
        },
        checkDuplicate: null,
        duplicateMsg: t('supplier.alreadyExists', 'Este proveedor ya existe en el sistema.'),
    });

    const fetchSupplierData = useCallback(async (id) => {
        setIsEdit(true);
        setLoading(true);
        try {
            const response_location = await callApi('supplier_select', 'SELECT_BY_SUPPLIER_OFFICE_ID', { 'id_supplier': id }, userSession.token);
            const response = await callApi('supplier_select', 'SELECT_BY_SUPPLIER_ID', { 'id_supplier': id }, userSession.token);
            if (response.status === 200) {
                const dto = response.data[0];
                dto.id_supplier = id;
                dto.location = response_location.status === 200 ? response_location.data || [] : [];
                setAllInfo(dto);
            }
        } catch (error) {
            console.error("Error fetching supplier data:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (location.state && location.state.config) {
            const { config } = location.state;
            if (config.data?.id) {
                setIsNitDisabled(true);
                fetchSupplierData(config.data?.id);
            }
            else setIsNitDisabled(false);
        }
    }, [fetchSupplierData, location.state]);

    const save = (data) => {
        try {
            setLoading(true);
            if (isEdit) {
                callApi('supplier_alter', 'UPDATE', data, userSession.token);
                sendNotification({
                    msg: t("messages.saveSuccess"),
                    variant: "success",
                });
            } else {
                callApi('supplier_alter', 'INSERT', data, userSession.token);
                sendNotification({
                    msg: t("messages.saveSuccess"),
                    variant: "success",
                });
            }
        } catch (error) {
            console.error("Error fetching supplier data:", error);
        } finally {
            setLoading(false);
        }
    }

    const handleGetDianInfo = () => {
        if (values.identification && values.type_identification) {
            fetchDianInfo(values);
            if (values.type_identification === "31")
                handleDirectInputChange('identification_digit', calculateDV(values.identification));
        }
    };

    return (
        {
            values,
            errorInputs,
            loading,
            isEdit,
            isNitDisabled,
            loadingDian,
            handleGetDianInfo,
            handleInputChange,
            handleDirectInputChange,
            validForm,
            sendNotification,
            save,
            t
        }
    )
}